var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_c('div',{staticClass:"honour"},[_c('img',{attrs:{"src":"http://icon.szfw.org/sf.png","alt":""}})]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","target":"_blank"}},[_vm._v("鄂ICP备20012389号-4")])])
}]

export { render, staticRenderFns }